import React, { useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import CameraSettingsColumns from './CameraSettingsColumns';
import ComplexSettingsColumns from './ComplexSettingsColumns';
import PresetsSettingsColumns from './PresetsSettingsColumns';
import ExportSettingsColumns from './ExportSettingsColumns';
import UserAndRoleColumns from './UserAndRoleColumns';
import WantedExceptionColumns from './WantedExceptionColumns';
import ViolationColumns from './ViolationColumns';
import { filterRoutes } from '../../../utils/routeByRoles';
import { getAuthorizedData } from '../../Authorized/reducer';

export default function SettingsPage() {
  const [selectedMenu, setSelectedMenu] = useState(null);
  const intl = useIntl();
  const { formatMessage } = intl;
  const { authorizedData } = useSelector(getAuthorizedData);
  const permissions = authorizedData && authorizedData.role && authorizedData.role.permissions ? authorizedData.role.permissions : {};

  const settingsMenu = [
    {
      value: 0, label: formatMessage({ id: 'menu.settings_calibrate_camera' }), component: CameraSettingsColumns, permission: ['settings_camera'],
    },
    {
      value: 1, label: formatMessage({ id: 'menu.settings_complex' }), component: ComplexSettingsColumns, permission: ['settings_complex'],
    },
    {
      value: 2, label: formatMessage({ id: 'menu.settings_presets' }), component: PresetsSettingsColumns, permission: ['settings_presets'],
    },
    {
      value: 4, label: formatMessage({ id: 'menu.settings_export' }), component: ExportSettingsColumns, permission: ['settings_export'],
    },
    {
      value: 5, label: formatMessage({ id: 'menu.settings_user' }), component: UserAndRoleColumns, permission: ['settings_user'],
    },
    {
      value: 6, label: formatMessage({ id: 'menu.settings_wanted' }), component: WantedExceptionColumns, permission: ['settings_wanted'],
    },
    {
      value: 7, label: formatMessage({ id: 'menu.settings_violation' }), component: ViolationColumns, permission: ['settings_violation'],
    },
  ];

  const filteredSettingsMenu = filterRoutes(settingsMenu, false, permissions, null, false, true);
  const selectedItem = filteredSettingsMenu.find(item => item.value === selectedMenu);
  const Component = selectedItem && selectedItem.component ? selectedItem.component : null;
  return (
    <div className="page settings-page">
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.settings' })}</div>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="settings-wrapper">
            <div className="settings-menu frame">
              <div className="settings-header">
                <div className="settings-label">{formatMessage({ id: 'custom.sections' })}</div>
                <div className="settings-buttons" />
              </div>
              <div className="settings-list-wrapper">
                <div className="settings-list custom-scroll-theme">
                  {filteredSettingsMenu.map((item, key) => (
                    <div
                      key={key}
                      onClick={() => { setSelectedMenu(item.value); }}
                      className={classNames('settings-menu-item', { selected: selectedMenu === item.value })}
                    >{item.label}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {Component
              ? <Component />
              : (
                <>
                  <div className="settings-category frame" />
                  <div className="settings-options frame" />
                </>
              )}
          </div>
        </div>
      </div>
    </div>
  );
}
